import Text from '../text/text'
import { NavLink as RemixNavLink } from 'react-router'
import type { RelatedEventDate } from '~/types/event'
import { getMonthDateTimeFromTo } from '~/utils/dates/datetime-misc'
import { useClientLang } from '~/utils/i18n.utils'
import { getImgSrc } from '~/utils/image'
import { trackClick } from '~/utils/statistics/statistics.helper'

export default function RelatedEvent({ event }: { event: RelatedEventDate }) {
	const lng = useClientLang()
	return (
		<div className="relative col-span-12 transition duration-200 hover:opacity-80 sm:col-span-6 md:col-span-6 lg:col-span-4 xl:col-span-3">
			<RemixNavLink
				className="flex flex-col rounded-xl"
				to={event.url}
				state={{ from: 'internal' }}
				onClick={() => trackClick(event.dateId, 'related')}
			>
				<div className="relative w-full">
					<img
						src={getImgSrc(event?.imageId, 'event')}
						alt={event?.title}
						className="aspect-video w-full rounded-t-xl object-cover"
						loading="lazy"
					/>

					<div className="absolute bottom-0 left-0 right-0 top-0 bg-linear-to-t from-black/80 via-black/20 to-transparent"></div>
					<div className="absolute bottom-2 left-2 right-2">
						<Text
							as="h3"
							className="truncate text-h2! leading-6! text-white drop-shadow-xl"
						>
							{event.title}
						</Text>
					</div>
				</div>
				<div className="rounded-b-xl border-b border-l border-r border-border bg-card p-2">
					{event.city && event.country && (
						<Text as="sm" className="truncate font-semibold">
							{event.city}, {event.country}
						</Text>
					)}
					{event.dateFrom && (
						<Text as="sm" className="truncate align-middle">
							{getMonthDateTimeFromTo({
								date: event.dateFrom,
								lng: lng.lngShort,
								timeZone: event.timeZone,
								dateTo: event.dateTo,
								short: true,
							})}
						</Text>
					)}
				</div>
			</RemixNavLink>
		</div>
	)
}
